import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppTableComponent, Form, FormElement, RequestsService, TranslationManager, ViewState, RequestSaveModel, MessagesComponent, RequestDetailsModel, BudgetStatusesService, BudgetStatusesModel, ProcurementCategoryBasicDetailsModel, ProcurementCategoriesService, ProcurementModelsService, ProcurementModelBasicModel, RequestAssignedUserHistoryModel } from 'src/common';
import { ProcurementCategorySelectComponent } from 'src/views';

@Component({
  selector: 'request-basic-information',
  templateUrl: 'request-basic-information.component.html'
})

export class RequestBasicInformationComponent implements OnInit {

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @ViewChild("procurementCategorySelect") procurementCategorySelect: ProcurementCategorySelectComponent;

  @Input() id: number;
  @Input() state: ViewState;
  form: Form = new Form();
  viewState = ViewState;

  budgetStatuses: BudgetStatusesModel[];
  procurementModels: ProcurementModelBasicModel[];
  requestAssignedUserHistoryList: RequestAssignedUserHistoryModel[];
  translationManager = TranslationManager;

  constructor(private requestsService: RequestsService,
    private budgetStatusesService: BudgetStatusesService,
    private procurementCategoriesService: ProcurementCategoriesService,
    private procurementModelsService: ProcurementModelsService,
    private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.initForm();

    if (this.state === ViewState.Edit || this.state === ViewState.Create) {
      this.budgetStatusesService.getAll().then((items: BudgetStatusesModel[]) => {
        this.budgetStatuses = items;
      });

      this.procurementModelsService.getAll().then((items: ProcurementModelBasicModel[]) => {
        this.procurementModels = items;
      });
    }

    if (this.state === ViewState.Edit || this.state === ViewState.Details) {
      this.form.elements['id'].value = this.id;
      this.requestsService.getById(this.form.elements['id'].value).then((item: RequestDetailsModel) => {
        this.mapModelToForm(item);
        this.requestAssignedUserHistoryList = item.requestAssignedUserHistoryList;
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });
    }
  }

  private mapModelToForm(item: RequestDetailsModel) {
    this.form.elements['id'].value = item.id;
    this.form.elements['requestName'].value = item.requestName;
    this.form.elements['budgetStatusId'].value = item.budgetStatusId;
    this.form.elements['procurementCategoryId'].value = item.procurementCategoryId;
    this.form.elements['procurementCategoryName'].value = item.procurementCategoryName;

    this.form.elements['procurementModelId'].value = item.procurementModelId;
    this.form.elements['requestStatus'].value = item.requestStatus;
    this.form.elements['requestAssignedUser'].value = item.requestAssignedUser;
    this.form.elements['requestAssignedUserErpId'].value = item.requestAssignedUserErpId;
    this.form.elements['requestSubject'].value = item.requestSubject;
    this.form.elements['plannedRoundsNumber'].value = item.plannedRoundsNumber;

    this.form.elements['createdByName'].value = item.createdByName;
    this.form.elements['createdOn'].value = item.createdOn;
    this.form.elements['updatedByName'].value = item.updatedByName;
    this.form.elements['updatedOn'].value = item.updatedOn;
  }

  private initForm(): void {
    this.form.elements["id"] = new FormElement();
    this.form.elements["requestName"] = new FormElement();
    this.form.elements["requestName"].state.mandatory = true;

    this.form.elements["budgetStatusId"] = new FormElement();
    this.form.elements["budgetStatusId"].state.mandatory = true;

    this.form.elements["procurementCategoryId"] = new FormElement();
    this.form.elements["procurementCategoryId"].state.mandatory = true;
    this.form.elements["procurementCategoryName"] = new FormElement();

    this.form.elements["procurementModelId"] = new FormElement();
    this.form.elements["procurementModelId"].state.mandatory = true;

    this.form.elements["requestStatus"] = new FormElement();
    this.form.elements["requestAssignedUser"] = new FormElement();
    this.form.elements["requestAssignedUserErpId"] = new FormElement();

    this.form.elements["requestSubject"] = new FormElement();
    this.form.elements["requestSubject"].state.mandatory = true;

    this.form.elements["plannedRoundsNumber"] = new FormElement();
    this.form.elements["plannedRoundsNumber"].state.mandatory = false;

    this.form.elements["createdByName"] = new FormElement();
    this.form.elements["createdOn"] = new FormElement();
    this.form.elements["updatedByName"] = new FormElement();
    this.form.elements["updatedOn"] = new FormElement();
  }

  submit() {
    if (this.form.isValid()) {

      let model: RequestSaveModel = new RequestSaveModel();

      model.id = this.form.elements['id'].value;
      model.requestName = this.form.elements['requestName'].value;
      model.budgetStatusId = this.form.elements['budgetStatusId'].value;
      model.procurementCategoryId = this.form.elements['procurementCategoryId'].value;
      model.procurementModelId = this.form.elements['procurementModelId'].value;
      model.requestSubject = this.form.elements['requestSubject'].value;
      model.plannedRoundsNumber = this.form.elements['plannedRoundsNumber'].value;

      this.requestsService.save(model).then(() => {
        if (this.state == ViewState.Create) {
          MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);
        } else if (this.state == ViewState.Edit) {
          MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно измењени')]);
        }

        this.navigateToList();
      });
    }
  }

  changeBudgetStatus(id: number) {
    this.form.elements['budgetStatusId'].value = id;
  }

  changeProcurementModel(id: number) {
    this.form.elements['procurementModelId'].value = id;
  }

  selectProcurementCategory() {
    this.procurementCategorySelect.showModal().then((id: number) => {
      if (id) {
        this.form.elements['procurementCategoryId'].value = id;
        this.getProcurementCategoryById(this.form.elements['procurementCategoryId'].value);
      }
    });
  }

  private getProcurementCategoryById(id: number) {
    this.procurementCategoriesService.getBasicById(id).then((item: ProcurementCategoryBasicDetailsModel) => {
      this.form.elements['procurementCategoryName'].value = item.name;
    });
  }

  navigateToList() {
    this.router.navigate(['/requests']);
  }
}
